"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalUkProject = exports.localProjectWPIds = exports.localProjectIds = exports.localProjects = exports.localProjectIdMapper = exports.projectLocationAddonMapper = exports.UKReforestationProject = exports.AUReforestationProject = exports.USReforestationProject = void 0;
exports.USReforestationProject = {
    id: 'us-reforestation-project-v3',
    projectId: 1364,
    price: 2.0,
    country: 'US',
    countryNiceCopy: 'the United States',
    countryNiceCopyShort: 'the US',
    link: '/projects/rewilding-the-appalachia-usa',
};
exports.AUReforestationProject = {
    id: 'au-reforestation-project-v3',
    projectId: 1352,
    price: 7.2,
    country: 'AU',
    countryNiceCopy: 'Australia',
    countryNiceCopyShort: 'Aus',
    link: '/projects/wildlife-corridors-koalas-australia',
};
exports.UKReforestationProject = {
    id: 'uk-reforestation-project-v3',
    projectId: 1401,
    price: 5.0,
    country: 'UK',
    countryNiceCopy: 'the United Kingdom',
    countryNiceCopyShort: 'the UK',
    link: '/projects/reforestation-projects-in-the-uk',
};
/**
 * Local Brazilian trees are only sold on the impact shop (not as a subscription addon)
 */
const BRReforestationProject = {
    id: '',
    projectId: 7208,
    price: 0,
    country: 'BR',
    countryNiceCopy: 'Brazil',
    countryNiceCopyShort: 'Brazil',
    link: '/projects/restoring-degraded-land-in-brazil',
};
exports.projectLocationAddonMapper = {
    US: exports.USReforestationProject,
    AU: exports.AUReforestationProject,
    GB: exports.UKReforestationProject,
};
exports.localProjectIdMapper = {
    1364: exports.USReforestationProject,
    1352: exports.AUReforestationProject,
    1401: exports.UKReforestationProject,
    7208: BRReforestationProject,
};
exports.localProjects = [exports.UKReforestationProject, exports.USReforestationProject, exports.AUReforestationProject];
exports.localProjectIds = exports.localProjects.map(p => p.id); // strings (uk-reforestation-project)
exports.localProjectWPIds = exports.localProjects.map(p => p.projectId); // numbers (1401)
const isLocalUkProject = (projectId) => projectId === exports.UKReforestationProject.projectId;
exports.isLocalUkProject = isLocalUkProject;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWwtcHJvamVjdHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdHJlZS1wcm9qZWN0cy9sb2NhbC1wcm9qZWN0cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFvQmEsUUFBQSxzQkFBc0IsR0FBc0I7SUFDdkQsRUFBRSxFQUFFLDZCQUE2QjtJQUNqQyxTQUFTLEVBQUUsSUFBSTtJQUNmLEtBQUssRUFBRSxHQUFHO0lBQ1YsT0FBTyxFQUFFLElBQUk7SUFDYixlQUFlLEVBQUUsbUJBQW1CO0lBQ3BDLG9CQUFvQixFQUFFLFFBQVE7SUFDOUIsSUFBSSxFQUFFLHdDQUF3QztDQUMvQyxDQUFDO0FBRVcsUUFBQSxzQkFBc0IsR0FBc0I7SUFDdkQsRUFBRSxFQUFFLDZCQUE2QjtJQUNqQyxTQUFTLEVBQUUsSUFBSTtJQUNmLEtBQUssRUFBRSxHQUFHO0lBQ1YsT0FBTyxFQUFFLElBQUk7SUFDYixlQUFlLEVBQUUsV0FBVztJQUM1QixvQkFBb0IsRUFBRSxLQUFLO0lBQzNCLElBQUksRUFBRSwrQ0FBK0M7Q0FDdEQsQ0FBQztBQUVXLFFBQUEsc0JBQXNCLEdBQXNCO0lBQ3ZELEVBQUUsRUFBRSw2QkFBNkI7SUFDakMsU0FBUyxFQUFFLElBQUk7SUFDZixLQUFLLEVBQUUsR0FBRztJQUNWLE9BQU8sRUFBRSxJQUFJO0lBQ2IsZUFBZSxFQUFFLG9CQUFvQjtJQUNyQyxvQkFBb0IsRUFBRSxRQUFRO0lBQzlCLElBQUksRUFBRSw0Q0FBNEM7Q0FDbkQsQ0FBQztBQUVGOztHQUVHO0FBQ0gsTUFBTSxzQkFBc0IsR0FBeUI7SUFDbkQsRUFBRSxFQUFFLEVBQUU7SUFDTixTQUFTLEVBQUUsSUFBSTtJQUNmLEtBQUssRUFBRSxDQUFDO0lBQ1IsT0FBTyxFQUFFLElBQUk7SUFDYixlQUFlLEVBQUUsUUFBUTtJQUN6QixvQkFBb0IsRUFBRSxRQUFRO0lBQzlCLElBQUksRUFBRSw2Q0FBNkM7Q0FDcEQsQ0FBQztBQUVXLFFBQUEsMEJBQTBCLEdBRW5DO0lBQ0YsRUFBRSxFQUFFLDhCQUFzQjtJQUMxQixFQUFFLEVBQUUsOEJBQXNCO0lBQzFCLEVBQUUsRUFBRSw4QkFBc0I7Q0FDM0IsQ0FBQztBQUVXLFFBQUEsb0JBQW9CLEdBRTdCO0lBQ0YsSUFBSSxFQUFFLDhCQUFzQjtJQUM1QixJQUFJLEVBQUUsOEJBQXNCO0lBQzVCLElBQUksRUFBRSw4QkFBc0I7SUFDNUIsSUFBSSxFQUFFLHNCQUFzQjtDQUM3QixDQUFDO0FBRVcsUUFBQSxhQUFhLEdBQUcsQ0FBQyw4QkFBc0IsRUFBRSw4QkFBc0IsRUFBRSw4QkFBc0IsQ0FBVSxDQUFDO0FBRWxHLFFBQUEsZUFBZSxHQUFHLHFCQUFhLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMscUNBQXFDO0FBQ3JGLFFBQUEsaUJBQWlCLEdBQUcscUJBQWEsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxpQkFBaUI7QUFFaEYsTUFBTSxnQkFBZ0IsR0FBRyxDQUFDLFNBQWlCLEVBQUUsRUFBRSxDQUFDLFNBQVMsS0FBSyw4QkFBc0IsQ0FBQyxTQUFTLENBQUM7QUFBekYsUUFBQSxnQkFBZ0Isb0JBQXlFIn0=